export const TextFontSizes = {
  xxSmallPx: '9px',
  xxSmallLineHeightPx: '12px',

  xSmall: '13px',
  xSmallLineHeight: '15px',

  smallPx: '14px',
  smallLineHeightPx: '17px',

  normal: '15px',
  normalLineHeight: '19px',

  mediumPx: '16px',
  mediumLineHeightPx: '21px',

  largePx: '24px',
  largeLineHeightPx: '29px',

  xLargePx: '36px',
  xLargeLineHeightPx: '42px',

  xxLargePx: '58px',
  xxLargeLineHeightPx: '76px'
};

export const ButtonFontSizes = {
  medium: '16px',
  mediumLineHeight: '21px',
  large: '16px',
  largeLineHeightPx: '21px'
};

// https://github.com/jonathantneal/css-font-weight-names
export const FontWeights = {
  light: '300',
  normal: '400',
  medium: '500',
  semiBold: '600',
  bold: '700'
};

export const FontFamilies = {
  roboto: "'Roboto', sans-serif"
};
